var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOngoing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_60)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.7221 40.3314C23.718 40.1748 23.716 40.0177 23.716 39.8601C23.716 30.5485 30.8583 23 39.6687 23C43.9078 23 47.7607 24.7474 50.6177 27.5979C50.892 27.8716 51.1571 28.1554 51.4125 28.4489",
    stroke: "#0082F9",
    strokeWidth: 6.19695
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7159 52.8047L15.3016 39.8062L32.1303 39.8062L23.7159 52.8047Z",
    fill: "#0082F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2721 39.8186C56.2761 39.9751 56.2781 40.1322 56.278 40.2898C56.2738 49.6014 49.1282 57.1468 40.3177 57.1428C36.0787 57.1409 32.2266 55.3917 29.3708 52.54C29.0967 52.2662 28.8317 51.9822 28.5764 51.6887",
    stroke: "#0082F9",
    strokeWidth: 6.19695
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2838 27.3453L64.6924 40.3476L47.8636 40.34L56.2838 27.3453Z",
    fill: "#0082F9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 36,
    stroke: "#0082F9",
    strokeWidth: 8
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_60"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOngoing);
export default __webpack_public_path__ + "static/media/Ongoing.a08eca504395a28509cec19ef6160c43.svg";
export { ForwardRef as ReactComponent };